import { useEffect } from "react";

const BASE = "https://summit.obalroku.cz";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
};

export const usePageMeta = ({ title, description, image, path }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsert('meta[property="og:title"]', { property: "og:title", content: title });
      upsert('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    if (description) {
      upsert('meta[name="description"]', { name: "description", content: description });
      upsert('meta[property="og:description"]', { property: "og:description", content: description });
      upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    if (image) {
      const abs = `${BASE}${image}`;
      upsert('meta[property="og:image"]', { property: "og:image", content: abs });
      upsert('meta[property="og:image:secure_url"]', { property: "og:image:secure_url", content: abs });
      upsert('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
      upsert('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
      upsert('meta[name="twitter:image"]', { name: "twitter:image", content: abs });
    }
    if (path) {
      upsert('meta[property="og:url"]', { property: "og:url", content: `${BASE}${path}` });
    }
  }, [title, description, image, path]);
};
